export default {
  modal_quick_access: {
    active: false,
  },
  modal_verify_code: {
    active: false,
  },
}
